'use strict';

var cov_24jsvueb23 = function () {
  var path = '/builds/CS-Development/overlay-messaging/src/main/adapters/cookieAdapter.js',
      hash = '90d620c02347fbfa35d38e67cef4668ed521d5d9',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/builds/CS-Development/overlay-messaging/src/main/adapters/cookieAdapter.js',
    statementMap: {
      '0': {
        start: {
          line: 12,
          column: 16
        },
        end: {
          line: 25,
          column: 1
        }
      },
      '1': {
        start: {
          line: 13,
          column: 17
        },
        end: {
          line: 16,
          column: 14
        }
      },
      '2': {
        start: {
          line: 18,
          column: 16
        },
        end: {
          line: 18,
          column: 18
        }
      },
      '3': {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 22,
          column: 3
        }
      },
      '4': {
        start: {
          line: 20,
          column: 20
        },
        end: {
          line: 20,
          column: 74
        }
      },
      '5': {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 35
        }
      },
      '6': {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 24,
          column: 75
        }
      },
      '7': {
        start: {
          line: 36,
          column: 16
        },
        end: {
          line: 44,
          column: 1
        }
      },
      '8': {
        start: {
          line: 38,
          column: 19
        },
        end: {
          line: 38,
          column: 94
        }
      },
      '9': {
        start: {
          line: 38,
          column: 63
        },
        end: {
          line: 38,
          column: 93
        }
      },
      '10': {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 42,
          column: 3
        }
      },
      '11': {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 53
        }
      },
      '12': {
        start: {
          line: 43,
          column: 2
        },
        end: {
          line: 43,
          column: 19
        }
      },
      '13': {
        start: {
          line: 55,
          column: 18
        },
        end: {
          line: 57,
          column: 1
        }
      },
      '14': {
        start: {
          line: 56,
          column: 2
        },
        end: {
          line: 56,
          column: 45
        }
      },
      '15': {
        start: {
          line: 63,
          column: 19
        },
        end: {
          line: 65,
          column: 1
        }
      },
      '16': {
        start: {
          line: 64,
          column: 2
        },
        end: {
          line: 64,
          column: 69
        }
      }
    },
    fnMap: {
      '0': {
        name: 'setItem',
        decl: {
          start: {
            line: 12,
            column: 25
          },
          end: {
            line: 12,
            column: 32
          }
        },
        loc: {
          start: {
            line: 12,
            column: 68
          },
          end: {
            line: 25,
            column: 1
          }
        },
        line: 12
      },
      '1': {
        name: 'getItem',
        decl: {
          start: {
            line: 36,
            column: 25
          },
          end: {
            line: 36,
            column: 32
          }
        },
        loc: {
          start: {
            line: 36,
            column: 38
          },
          end: {
            line: 44,
            column: 1
          }
        },
        line: 36
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 38,
            column: 53
          },
          end: {
            line: 38,
            column: 54
          }
        },
        loc: {
          start: {
            line: 38,
            column: 63
          },
          end: {
            line: 38,
            column: 93
          }
        },
        line: 38
      },
      '3': {
        name: 'isItemSet',
        decl: {
          start: {
            line: 55,
            column: 27
          },
          end: {
            line: 55,
            column: 36
          }
        },
        loc: {
          start: {
            line: 55,
            column: 42
          },
          end: {
            line: 57,
            column: 1
          }
        },
        line: 55
      },
      '4': {
        name: 'deleteItem',
        decl: {
          start: {
            line: 63,
            column: 28
          },
          end: {
            line: 63,
            column: 38
          }
        },
        loc: {
          start: {
            line: 63,
            column: 44
          },
          end: {
            line: 65,
            column: 1
          }
        },
        line: 63
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 12,
            column: 38
          },
          end: {
            line: 12,
            column: 50
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 12,
            column: 48
          },
          end: {
            line: 12,
            column: 50
          }
        }],
        line: 12
      },
      '1': {
        loc: {
          start: {
            line: 12,
            column: 52
          },
          end: {
            line: 12,
            column: 66
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 12,
            column: 65
          },
          end: {
            line: 12,
            column: 66
          }
        }],
        line: 12
      },
      '2': {
        loc: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        }, {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        }],
        line: 19
      },
      '3': {
        loc: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        }, {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        }],
        line: 40
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0
    },
    b: {
      '0': [0],
      '1': [0],
      '2': [0, 0],
      '3': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
cov_24jsvueb23.s[0]++;
/**
 * Store a value in a cookie.
 *
 * @param  {string}  key                The key for the value.
 * @param  {string}  payload            The value to store. Empty string by default.
 * @param  {number}  expiration         The optional lifespan of the stored
 *                                        value in seconds.
 * @returns {void}
 *
 * @public
 */
var setItem = function setItem(key) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_24jsvueb23.b[0][0]++, '');
  var expiration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_24jsvueb23.b[1][0]++, 0);
  cov_24jsvueb23.f[0]++;

  var domain = (cov_24jsvueb23.s[1]++, window.location.hostname.split('.').splice(1).join('.'));

  var expData = (cov_24jsvueb23.s[2]++, '');
  cov_24jsvueb23.s[3]++;
  if (expiration > 0) {
    cov_24jsvueb23.b[2][0]++;

    var expDate = (cov_24jsvueb23.s[4]++, new Date(Date.now() + 1000 * expiration).toUTCString());
    cov_24jsvueb23.s[5]++;
    expData = 'expires=' + expDate;
  } else {
    cov_24jsvueb23.b[2][1]++;
  }

  cov_24jsvueb23.s[6]++;
  document.cookie = key + '=' + payload + ';path=/;domain=' + domain + ';' + expData;
};

/**
 * Reads a cookie with a given name from a cookie.
 *
 * @param   {string}  key               The name of the cookie.
 *
 * @returns  {Object}                   The value stored in the cookie.
 *
 * @public
 */
cov_24jsvueb23.s[7]++;
var getItem = function getItem(key) {
  cov_24jsvueb23.f[1]++;

  // Filters the array and returns just the cookie we're interested in.
  var myCookie = (cov_24jsvueb23.s[8]++, document.cookie.split(';').filter(function (cookie) {
    cov_24jsvueb23.f[2]++;
    cov_24jsvueb23.s[9]++;
    return cookie.indexOf(key + '=') > -1;
  }));

  cov_24jsvueb23.s[10]++;
  if (myCookie.length) {
    cov_24jsvueb23.b[3][0]++;
    cov_24jsvueb23.s[11]++;

    return myCookie[0].replace(key + '=', '').trim();
  } else {
    cov_24jsvueb23.b[3][1]++;
  }
  cov_24jsvueb23.s[12]++;
  return undefined;
};

/**
 * Checks whether a cookie with a given name is set.
 *
 * @param   {string}  key               The name of the cookie.
 *
 * @returns  {Boolean}                  Boolean value whether cookie is set or not.
 *
 * @public
 */
cov_24jsvueb23.s[13]++;
var isItemSet = function isItemSet(key) {
  cov_24jsvueb23.f[3]++;
  cov_24jsvueb23.s[14]++;

  return typeof getItem(key) !== 'undefined';
};

/**
 * Delete a cookie with a given name
 * @param {string} key The name of the cookie.
 */
cov_24jsvueb23.s[15]++;
var deleteItem = function deleteItem(key) {
  cov_24jsvueb23.f[4]++;
  cov_24jsvueb23.s[16]++;

  document.cookie = key + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};
exports.getItem = getItem;
exports.setItem = setItem;
exports.isItemSet = isItemSet;
exports.deleteItem = deleteItem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@wh/overlay-messaging/dist/adapters/cookieAdapter.js
// module id = 12
// module chunks = 0